module.exports = __webpack_public_path__ + "static/media/MD_MASARY_About_header.389dafb2.jpg";